import React, { useCallback } from 'react';
import { Box, Checkbox, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

interface StyledAgreementButtonProps {
  hasAgreedToCertification: boolean;
}

const StyledAgreementButton = styled(RawButton)<StyledAgreementButtonProps>`
  border-radius: ${({ theme }) => theme.rounds.container2Round};
  padding: ${({ theme }) => theme.spacings.spacing8};
  background-color: ${({ theme, hasAgreedToCertification }) => hasAgreedToCertification
    ? theme.colors.border2
    : undefined};
  ${({ theme }) => theme.border.grey5};

  &:hover {
    background-color: ${({ theme }) => theme.colors.border2};
  }
`;

interface Props {
  hasAgreedToCertification: boolean;
  setHasAgreedToCertification: (value: boolean) => void;
}

const AgreementButton: React.FC<Props> = ({ hasAgreedToCertification, setHasAgreedToCertification }) => {
  const toggleAgreement = useCallback(() => {
    setHasAgreedToCertification(!hasAgreedToCertification);
  }, [hasAgreedToCertification, setHasAgreedToCertification]);

  return (
    <StyledAgreementButton
      margin={{ top: 'spacing12' }}
      pad="spacing8"
      hasAgreedToCertification={hasAgreedToCertification}
      onClick={toggleAgreement}
    >
      <Box
        direction="row"
        align="center"
      >
        <Checkbox
          testId="claim-summary-footer_agreement"
          checked={hasAgreedToCertification}
          isLarge
        />
        <Text weight={400}>
          I agree to the certification above
        </Text>
      </Box>
    </StyledAgreementButton>
  );
};

export default AgreementButton;
